import {CredencialContext} from "./CredencialContext";

export function ProvideCredencial({ children }) {

    return (
        <CredencialContext.Provider value={undefined}>
            {children}
        </CredencialContext.Provider>
    );
}